import React from 'react';

export default function Layout({ children }) {
  return (
    <>
      {/* Fixed header with centered logo */}
      <div className="fixed top-0 left-0 w-full bg-white p-2 z-50 flex justify-center items-center">
        <img
          src="/logo.png"
          alt="GrowithAI"
          className="w-12 h-12 md:w-16 md:h-16 lg:w-20 lg:h-20 object-contain"
        />
      </div>
      {/* Main content with top padding to offset fixed header */}
      <div className="pt-20 min-h-screen bg-gray-50">
        {children}
      </div>
    </>
  );
}
